<script>
import draggable from 'vuedraggable'
import lazyLoadComponent from '@router/lazyload-component'

export default {
	data() {
		return {
			drag: true,
			submitData: {
				title: 123,
				timeRange: [],
				terms: '',
				images: []
			},
			loading: false,
			closeIsActive: false,
			radio: '1',
			dataList: [{
				"openStatus": true
			}, {
				"openStatus": false
			}]
		};
	},
	computed: {
		submitRules() {
			return {
				title: [
					{
						required: true,
						message: '請填寫問題標題',
					},
				],
			}
		},
	},
	created() { },
	mounted() { },
	methods: {
		addNewGroup() { },
		onClickButton() { },
		onClickSave() { },
		typeChanged() { },
		/**
		 * @description 問題形式
		 */
		typeSelect(type) {
			const typeList = {
				'checkbox': '複選',
				'text': '簡答',
				'radio': '單選'
			}
			return typeList[type]
		},
		onPickSelectDate() { },
		openCloseCard() {
			this.$set(this.dataList[0], 'openStatus', !this.dataList[0].openStatus)
			this.$set(this.dataList[1], 'openStatus', !this.dataList[1].openStatus)
		},
	},
	components: {
		draggable,
		ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
	},
};
</script>


<template>
	<div>
		<div :class="$style.stage">
			<el-row :gutter="20" :class="$style.questionSet">
				<el-col :span="12">
					<h4>行程設定</h4>
				</el-col>
				<el-col :span="12">
					<el-button class="is-round" type="primary" plain @click="addNewGroup">
						<BaseIcon name="plus" />
						<span>新增行程</span>
					</el-button>
				</el-col>
			</el-row>
			<div v-for="item in dataList">
				<draggable animation="200" handle=".handle-subject" @start="drag = true" @end="drag = false">
					<transition-group type="transition" :name="!drag ? 'flip-list' : null">
						<div :key="1" :class="$style.outerStyle">
							<!-- 自訂題目標題列 -->
							<div :class="[$style.header]" @click="openCloseCard">
								<div :class="$style['header__title']">
									<el-button class="is-no-style"
										:class="[$style['header__angleButton'], closeIsActive ? '' : $style['header__angleButton__rotate']]">
										<BaseIcon name="angle-down" />
									</el-button>

									<span :class="$style['header__qTitle']">{{ submitData.title === '' ? `問題標題` : submitData.title
									}}</span>
									<div :class="$style['header__rightUser']">
										<span>{{ typeSelect(submitData.type) }}</span>
									</div>
								</div>
							</div>
							<!-- 自訂題目content -->
							<el-collapse-transition>
								<div v-if="item.openStatus" :class="$style.content">
									<el-form ref="form" :model="submitData" :rules="submitRules" label-position="top"
										class="el-form--floating">
										<el-row :gutter="20" :class="$style.marginBottom">
											<el-col :sm="24" :span="24">
												<el-form-item label="行程時間" class="mb-0">
													<el-time-picker v-model="submitData.timeRange" class="bg-white is-border" :clearable="false"
														range-separator="至" format="HH:mm" value-format="HH:mm" placeholder="選擇開始營業時間" is-range
														@change="onPickSelectDate(item, key, index)">
													</el-time-picker>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row :gutter="20" :class="$style.marginBottom">
											<el-col :sm="24" :span="24">
												<el-form-item label="" prop="terms" class="mb-0">
													<div>
														<span class="text-secondary">
															行程簡述
														</span>
													</div>
													<el-input v-model="submitData.terms" type="textarea" :autosize="{ minRows: 7 }"
														class="bg-white is-round is-border" />
												</el-form-item>
											</el-col>
										</el-row>

										<el-row :gutter="20" :class="$style.marginBottom">
											<el-col :sm="24" :span="24">
												<el-form-item label="行程圖片" prop="terms" class="mb-0">
													<ImageUpload v-model="submitData.images" :class="$style.upload" :show-upload="true"
														:resource="'product'" :propsMoreHW="true" :immediate-delete="false">
													</ImageUpload>
												</el-form-item>
											</el-col>
										</el-row>

										<div :class="$style.footer">
											<el-row :gutter="20">
												<el-col :sm="12" :span="24">
													<el-button class="is-round is-full" @click="onClickButton('remove')">刪除</el-button>
												</el-col>
												<el-col :sm="12" :span="24">
													<el-button class="is-round is-full" :loading="loading" type="primary" @click="onClickSave">
														<BaseIcon name="check" />
														<span>儲存問題</span>
													</el-button>
												</el-col>
											</el-row>
										</div>
									</el-form>
								</div>
							</el-collapse-transition>
						</div>
					</transition-group>
				</draggable>
			</div>
		</div>
	</div>
</template>

<style lang="scss" module>

.outerStyle {
	border: 1px solid $color-line-dark;
	border-radius: $border-radius;
}

.stage {
	padding: 18px 20px 60px;
	background-color: white;
}

.questionSet {
	margin-bottom: 11px;

	:global {
		.el-button {
			background-color: $color-primary;
			color: white;
			position: absolute;
			right: 10px;
		}
	}

	&~div {
		margin-bottom: 10px;
	}
}

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 2px solid $color-border-lighter;
	padding: 7px 20px;
	background-color: $color-line;
	border-top-left-radius: $border-radius;
	border-top-right-radius: $border-radius;
	height: 58px;
	cursor: pointer;

	h4 {
		display: inline-block;
		flex-shrink: 0;
	}

	&__title {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: space-between;
	}

	&__qTitle {
		padding-left: 20px;
	}

	&__angleButton {
		position: absolute;

		&__rotate {
			transform: rotate(180deg);
		}
	}

	&__rightUser {
		min-width: 290px;
		margin-left: 10px;
		display: flex;
		flex-grow: 1;
		justify-content: flex-end;
		align-items: center;

		&__switch {
			margin-right: 30px;
			margin-left: 30px;
		}

		@include max-md {
			flex-direction: column;
			justify-content: center;
			align-items: center;

			>* {
				margin-bottom: 10px;
			}
		}
	}

	[class*='fa-']+span {
		margin-left: 1.5em;
	}
}

.marginBottom {
	margin-bottom: 20px;
}

.content {
	padding: 24px 21px 50px;
}

.upload {
	border: 0;
}
</style>